// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GGKR","top":"styles_top__2r7RV","left":"styles_left__2slO-","description":"styles_description__cntq5"};